var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"padding-left":"40px"}},[(_vm.document)?_c('div',{staticStyle:{"font-weight":"bold"}},[_vm._v("关于 "+_vm._s(_vm.document.name)+" 的文档存证周转")]):_vm._e(),_c('div',{staticStyle:{"height":"400px"},attrs:{"id":"fileChainBox"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }